import adminTable from '@store/adminTable/reducers';

import { group_code } from '@Modules/GroupCode/configs/constants';

export default adminTable(group_code);
